import React from 'react';
import PropTypes from 'prop-types';

import useStyles from './form-section-wrapper.styles';

const FormSectionWrapper = ({
  sectionTitle,
  totalLabel,
  totalCount,
  emptyStateTitle,
  emptyStateSubtitle,
  mode = 'dark',
  containerClassName,
  children
}) => {
  const classes = useStyles({ mode });

  return (
    <div className={classes.container}>
      <div className={classes.subtitleRow}>
        <h2 className={classes.sectionSubtitle}>{sectionTitle}</h2>
        <div className={classes.totalLabel}>
          <span className={classes.totalText}>TOTAL</span>
          <span className={classes.totalCount}>
            {totalCount} {totalLabel}
          </span>
        </div>
      </div>
      {totalCount === 0 && (
        <div className={classes.bannerContainer}>
          <div className={classes.noItemsBanner}>
            <p className={classes.noItemsTitle}>{emptyStateTitle}</p>
            <p className={classes.noItemsSubtitle}>{emptyStateSubtitle}</p>
          </div>
        </div>
      )}
      <div className={containerClassName || classes.contentContainer}>{children}</div>
    </div>
  );
};

FormSectionWrapper.propTypes = {
  sectionTitle: PropTypes.string.isRequired,
  totalLabel: PropTypes.string.isRequired,
  totalCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  emptyStateTitle: PropTypes.string,
  emptyStateSubtitle: PropTypes.string,
  isEmpty: PropTypes.bool,
  containerClassName: PropTypes.string,
  children: PropTypes.node,
  mode: PropTypes.oneOf(['dark', 'light'])
};

FormSectionWrapper.defaultProps = {
  emptyStateTitle: '',
  emptyStateSubtitle: 'To add one select from below',
  isEmpty: false,
  containerClassName: null,
  children: null
};

export default FormSectionWrapper;
